import { fromJS } from 'immutable';

export default {
    setInstallers: (state, installers) => {
        return state.setIn(['list'], fromJS(installers)).set('initialized', true);
    },
    setInstallerDetails: (state, installer) => {
        return state.mergeIn(['list'], fromJS(installer));
    },
    updateInstallerDetails: (state, installer) => {
        return state.mergeIn(['list'], fromJS(installer));
    },
    addInstaller: (state, installerId, installer) => {
        return state.setIn(['list', installerId], fromJS(installer));
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Installers/core.js